import React, { useEffect, useMemo, useState } from "react";

// Import components
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { deleteShift, updateShift } from "store/actions";
import CreateShift from "./CreateShift";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { convertToAMPM } from "helpers/format_helper";

import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const ShiftTable = ({ List, loading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId, setDeleteId] = useState();
  const [openModal, setOpenModal] = useState()
  const [confirmAction, setConfirmAction] = useState();

  const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

  const hasEditPermission = permissions2.some(item => item?.permissionName === "Edit Shifts");
  const hasDeletePermission = permissions2.some(item => item?.permissionName === "Delete Shifts");

  const handleDelete = (shiftId) => {
    dispatch(deleteShift(shiftId))
    setDeleteId('')
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction])

  const columns = useMemo(
    () => [
      {
        header: 'Shift Name',
        accessorKey: 'shiftName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Start Time',
        accessorKey: 'startTime',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ getValue }) => {
          const time = getValue();
          return convertToAMPM(time);
        }
      },
      {
        header: 'End Time',
        accessorKey: 'endTime',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ getValue }) => {
          const time = getValue();
          return convertToAMPM(time);
        }
      },
      ...(hasEditPermission || hasDeletePermission ? [{
        header: 'Actions',
        id: 'actions', // Unique id for this column
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            setEditData(rowData);
            setIsOpen(true);
            console.log('Edit clicked for row:', rowData);
          };

          return (
            <div className="d-flex gap-2">
              {permissions2?.map(item => item?.permissionName)?.includes("Edit Shifts") && <Button color="primary" onClick={handleEdit} className="mr-2">
                <FaRegEdit size={18} />
              </Button>}
              {permissions2?.map(item => item?.permissionName)?.includes("Delete Shifts") && <Button
                color="danger"
                onClick={() => { setDeleteId(row?.original?.shiftId); setOpenModal(true); }}
                className="mr-2"
              >
                <MdDeleteOutline size={18} />
              </Button>}
            </div>
          );
        },
      },
      ] : []),
    ],
    [hasEditPermission, hasDeletePermission]
  );

  const handleSubmit = (data) => {
    dispatch(updateShift(data));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  // Meta title
  document.title = "Shift Management | Admin Dashboard";

  return (
    <>
      <ConfirmationModal okText={"Confirm"} onCancel={() => { setDeleteId(''); setOpenModal(false); }} onOk={() => { setConfirmAction(true); }} isVisible={openModal} title="Delete Shift" content='Are You Sure You Want to Delete the Shift' />
      <CreateShift
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />
      <div className="">
        <div className="container-fluid">
          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Shifts"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default ShiftTable;
